import React from 'react';
import './featured.css'
import './card.css'
import Button from './button';
const Featured = (props) => {
    return ( <>
    <div className="eventCard featured">
        <img className='featuredimg' src={props.img} alt="" />
        <div className="featuredDeets">
            <h1>
                {props.title}
            </h1>
            <div className="featuredFlex">
                 <div className="detailsflex">
                <div className="deet">
                {props.date} | {props.time}
            </div>
            <div className="deet">
                {props.location} 
            </div>
            </div>
            <h2>
                    {props.price}<span>EGP
                </span>
                </h2>
            </div>
        </div>
        <Button class="btn1 btn3" cta="Book Now" />
    </div>
    </> );
}
 
export default Featured;